module.exports = __webpack_public_path__ + "img/algreen-logo.6e657fb4.jpg";